module.exports = __webpack_public_path__ + "static/media/python.a4c98194.svg";